// Shared utility helpers for the Ontology module.

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const kindBadgeClass = (kind) => {
  if (kind === 'class') return 'bg-[#002FA7]/10 text-[#002FA7]';
  if (kind === 'relation') return 'bg-[#AF52DE]/10 text-[#AF52DE]';
  return 'bg-[#34C759]/10 text-[#34C759]';
};

export const healthColor = (score) => {
  const s = score ?? 0;
  if (s >= 70) return '#34C759';
  if (s >= 40) return '#FF9500';
  return '#FF3B30';
};

// Lightweight markdown renderer for the GPT-authored brief.
// Supports ## headings, **bold**, and - bullets. Iterative, not recursive.
export const MarkdownBrief = ({ markdown }) => {
  const lines = (markdown || '').split('\n');
  const blocks = [];
  let bulletBuf = [];
  const flushBullets = () => {
    if (bulletBuf.length) {
      blocks.push({ type: 'ul', items: [...bulletBuf] });
      bulletBuf = [];
    }
  };
  for (const ln of lines) {
    if (ln.startsWith('## ')) {
      flushBullets();
      blocks.push({ type: 'h2', text: ln.slice(3).trim() });
    } else if (ln.startsWith('# ')) {
      flushBullets();
      blocks.push({ type: 'h2', text: ln.slice(2).trim() });
    } else if (ln.startsWith('- ') || ln.startsWith('* ') || ln.startsWith('• ')) {
      bulletBuf.push(ln.slice(2).trim());
    } else if (!ln.trim()) {
      flushBullets();
      blocks.push({ type: 'br' });
    } else {
      flushBullets();
      blocks.push({ type: 'p', text: ln.trim() });
    }
  }
  flushBullets();

  const renderInline = (text) => {
    // Handle **bold** segments iteratively
    const parts = text.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((p, i) => {
      if (p.startsWith('**') && p.endsWith('**')) {
        return <strong key={i} className="font-semibold text-[#111827]">{p.slice(2, -2)}</strong>;
      }
      return <span key={i}>{p}</span>;
    });
  };

  return (
    <div className="prose prose-sm max-w-none" data-testid="brief-markdown">
      {blocks.map((b, i) => {
        if (b.type === 'h2') return <h3 key={i} className="text-sm font-bold text-[#002FA7] mt-4 mb-1.5">{b.text}</h3>;
        if (b.type === 'ul') return (
          <ul key={i} className="list-disc pl-5 space-y-0.5 text-xs text-[#1F2937]">
            {b.items.map((it, j) => <li key={j}>{renderInline(it)}</li>)}
          </ul>
        );
        if (b.type === 'br') return <div key={i} className="h-1" />;
        return <p key={i} className="text-xs text-[#1F2937] leading-relaxed">{renderInline(b.text)}</p>;
      })}
    </div>
  );
};
